import React, { createContext, useEffect, useState } from 'react';
import { createCameraSessionPool } from '../services/cameraSessionService';

export const CameraSessionsContext = createContext(null);

export function CameraSessionsProvider({ streams, children }) {
  const [pool] = useState(createCameraSessionPool);
  useEffect(() => {
    const sessions = streams.map((stream) => pool.acquire(stream.id, stream.url, () => {}));
    pool.retain(streams);
    return () => sessions.forEach((session) => session.release());
  }, [pool, streams]);
  useEffect(() => () => pool.dispose(), [pool]);
  return <CameraSessionsContext.Provider value={pool}>{children}</CameraSessionsContext.Provider>;
}
